/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

import ClientInformation from './component/ClientInformation';
import Defendant from './component/Defendant';
import Summary from './component/Summary'; // component import start here
import CaseDetailsCustomFields from './component/CaseDetailsCustomFields';
import InformationDetails from './component/InformationDetails';
import ConflictCheck from './component/ConflictCheck';
import ImportantDates from './component/ImportantDates';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';

import { useCaseDetailsCustomField } from '../hooks/useCaseDetailsCustomField'; // hooks import start here

import { UserDetailsContext } from 'context/userDetailsContext'; //context import start here
import { useToast } from 'context/ToastContext';

import AppConstants from 'constants/index'; // constants import start here
import { toastConstant } from 'constants/toastmessage';

import { updateLeadDetails } from 'services/leadServices';

import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone'; // utils import start here
import { makeListUnique, getTenantDetails } from 'utils/utils';
import { parseDOB, formatDOB } from 'modules/lead/helpers/helpers';
import CompanionCases from './component/CompanionCases';
import { useCaseNotes } from '../hooks/useCaseNotes';
import NeedResolution from 'modules/lead/LeadDetails/components/Overview/components/NotesResolution/NeedResolution';
import CaseDetailsUnmappedFields from './component/CaseDetailsUnmappedFields';
import { useCaseContact } from '../hooks/useCaseContact';
import { useSecureMessages } from '../hooks/useSecureMessages';
import { queryKeys } from 'modules/LeadsV2/config/queryClient';
import { useQueryClient } from '@tanstack/react-query';

import 'assets/scss/style.scss';

export const Information = (props) => {
  const { isLeadSpecific, caseDetails, fetchLeadDetails, updateCaseDetails, getCaseDetails } = props;

  const userDetails = useContext(UserDetailsContext); //  context and hook declarations

  const { caseCustomFieldList } = useCaseDetailsCustomField();
  const { addToast } = useToast();
  const { caseNoteList, loadCaseNoteList } = useCaseNotes(
    { case_id: caseDetails?.case_id },
    undefined,
    isLeadSpecific,
    props?.isFromCaseSpecificModule,
    {
      isCase: !isLeadSpecific,
      isLeads: isLeadSpecific,
    }
  );
  const { caseSecureMessages, loadCaseSecureMessages } = useSecureMessages({
    case_id: caseDetails?.case_id,
    isLeadSpecific: props?.caseDetails?.is_lead || props?.isLeadSpecific ? props?.caseDetails?.is_lead || props?.isLeadSpecific : false,
    isFromCaseSpecificModule: props?.isFromCaseSpecificModule ? props?.isFromCaseSpecificModule : false,
    isGlobalMessagesScreen: false,
    resolution_status: true,
    options: {
      isCase: !isLeadSpecific,
      isLeads: isLeadSpecific,
    },
  });
  const { handleUpdateContact } = useCaseContact({ caseDetails, getDetails: getCaseDetails, isLeadSpecific });
  const queryClient = useQueryClient();

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors, dirtyFields },
  } = useForm();

  const [caseReopenDate, setCaseReopenDate] = useState(''); //  state declarations
  const [isCaseClosed, setIsCaseClosed] = useState(false);
  const [caseClosedDate, setCaseClosedDate] = useState('');

  const isPersonalInjuryCase = caseDetails?.case_description?._case_practice_area_ === 'Personal Injury';

  const fetchCaseNotes = () => {
    loadCaseNoteList({ limit: 1000, pagination_token: '', pagination_direction: 'forward', filter: { case_id: caseDetails.case_id } });
  };

  // to handle submit case details
  const handleUpdateCaseDetails = async (sendData) => {
    //---------------- setting up case info page  updated data into data fields --------------------
    let data = JSON.parse(JSON.stringify(caseDetails));
    let sendDataDescription = sendData?.case_description,
      sendDataDetails = sendData?.case_details;

    // Handle both string and object values for AsyncPaginate fields
    sendDataDescription.case_matter =
      typeof sendDataDescription?.case_matter === 'string'
        ? sendDataDescription.case_matter
        : sendDataDescription?.case_matter?.case_matter_id || sendDataDescription?.case_matter?.value || '';
    sendDataDescription.office_location =
      typeof sendDataDescription?.office_location === 'string'
        ? sendDataDescription.office_location
        : sendDataDescription?.office_location?.value || sendDataDescription?.office_location?.office_location_id || '';
    sendDataDescription.venue =
      typeof sendDataDescription?.venue === 'string'
        ? sendDataDescription.venue
        : sendDataDescription?.venue?.venue_id || sendDataDescription?.venue?.value || '';
    sendDataDescription.case_practice_area =
      typeof sendDataDescription?.case_practice_area === 'string'
        ? sendDataDescription.case_practice_area
        : sendDataDescription?.case_practice_area?.practice_area_id || sendDataDescription?.case_practice_area?.value || '';

    data.case_description = { ...(data?.case_description || {}), ...(sendDataDescription || {}) };
    data.case_details = { ...(data?.case_details || {}), ...(sendDataDetails || {}) };

    //------------------------- Start here ------- handling custom fields---------------------------

    let existingCustomField = sendData?.case_description?.custom_field ?? [];
    let remainingCustomFields = sendData?.unassigned_custom_field ?? [];

    let finalCustomfield = [...remainingCustomFields, ...existingCustomField];
    finalCustomfield = makeListUnique(finalCustomfield, 'custom_field_id');

    let assignedCustomField = [],
      unassignedCustomField = [];

    finalCustomfield.map((item) => {
      if ([0, null, undefined, '', 'undefined'].includes(item.value)) {
        unassignedCustomField = [...unassignedCustomField, item];
      } else {
        assignedCustomField = [...assignedCustomField, item];
      }
      return true;
    });
    setValue('case_description.custom_field', assignedCustomField);
    setValue('unassigned_custom_field', unassignedCustomField);
    data.case_description.custom_field = assignedCustomField;
    //------------------------ End here ------------------handling custom fields----------------------------

    //  data from lead details page

    if (isLeadSpecific) {
      data = {
        ...data,
        lead_details: {
          ...data?.lead_details,
          description: sendData?.description,
          tags: sendData?.tags,
          conflict_check: sendData?.lead_details?.conflict_check,
          conflict_contacts: sendData?.lead_details?.conflict_contacts,
          conflict_note: sendData?.lead_details?.conflict_note,
        },
      };
    }
    //  data from case details page
    else {
      data.case_description.case_stage = sendDataDescription?.case_stage || caseDetails?.case_description?.case_stage;
      data.case_description.case_name = sendDataDescription?.case_name ?? 'TBD';
      data.important_dates.statute_of_limitations = sendData?.important_dates?.statute_of_limitations || '';
      data.case_description.date_of_loss_event = sendData?.case_description?.date_of_loss_event
        ? setTimezoneWithoutAlteringTime(sendData?.case_description?.date_of_loss_event, userDetails?.userDetails?.timezone)
        : undefined;
      data.case_details.description = sendData?.description;
      data.case_details.tags = sendData?.tags;
      data.case_details.is_create_client_portal = sendData?.is_create_client_portal; //detail page
      data.case_details.conflict_check = sendData?.lead_details?.conflict_check; // conflict check page
      data.case_details.conflict_note = sendData?.lead_details?.conflict_note;
      data.case_details.conflict_contacts = sendData?.lead_details?.conflict_contacts;
    }

    data.stage_change =
      caseDetails?.case_description?.case_stage?.case_stage_id !== sendDataDescription?.case_stage?.case_stage_id ? 'true' : 'false';
    data.case_practice_area_sk = sendData?.case_practice_area_sk || undefined;
    data.case_description.case_status = isCaseClosed ? 'Closed' : 'Open';
    setValue('case_description.custom_field_toggle', false);
    data.online_lead_fields = sendData?.online_lead_fields;

    let { description, tags, is_create_client_portal, conflict_check, conflict_note, unassigned_custom_field, ...rest } = data; // to delete unwanted fields
    data = { ...rest };
    delete data.case_description.custom_field_toggle; // deleting unwanted fields

    const dobChanged = dirtyFields?.dob;
    const contactData = {
      ...caseDetails?.client_details?.[0],
      ...(dobChanged ? { dob: sendData?.dob instanceof Date ? formatDOB(sendData.dob) : sendData?.dob } : {}),
    };

    if (!isLeadSpecific) {
      updateCaseDetails(data, false).then(() => {});
    } else {
      updateLeadDetails(data.sk, data)
        .then(() => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.LEAD_UPDATE_SUCCESS);
          fetchLeadDetails();
          queryClient.invalidateQueries({ queryKey: queryKeys.leads.all });
        })
        .catch((error) => {
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.LEAD_UPDATE_FAILURE);
        });
    }

    if (dobChanged) {
      let contactPayload = { ...contactData };
      let tenantId = getTenantDetails()[0];
      let contactId = contactPayload.contact_id;

      if (contactId && tenantId) {
        delete contactPayload.pk;
        delete contactPayload.sk;
        contactPayload.pk = `${tenantId}#${contactId}`;
        contactPayload.sk = `contact#${contactId}`;
      }
      handleUpdateContact(contactPayload, true);
    }
  };

  useEffect(() => {
    if (isLeadSpecific) {
      fetchCaseNotes();
    }
  }, []);

  // for inital load of case details page
  useEffect(() => {
    if (caseDetails?.pk && caseDetails?.sk) {
      setCaseClosedDate(caseDetails?.case_closed_date);
      setCaseReopenDate(caseDetails?.case_reopen_date);
      if (caseDetails?.is_open === false && caseDetails?.is_lead === true) {
        setIsCaseClosed(true);
      } else if (caseDetails?.status === 'INACTIVE') {
        setIsCaseClosed(true);
      } else if (caseDetails?.status === 'ACTIVE') {
        setIsCaseClosed(false);
      }
    }
    let caseDetailsField = caseDetails?.case_details;
    let caseDescription = caseDetails?.case_description;

    //custom Fields
    let existingCustomFieldList = caseDetails?.case_description?.custom_field
      ?.filter((data) => data.value && data.custom_field_id)
      ?.map((c) => {
        let item2 = caseCustomFieldList?.find((item) => item?.custom_field_id === c?.custom_field_id);
        if (item2) {
          c.position = item2?.position;
        }
        return c;
      })
      ?.sort((a, b) => a?.position - b?.position);

    let assignedCustomField = [],
      unassignedCustomField = [];

    if (Array.isArray(caseCustomFieldList) && caseCustomFieldList.length) {
      let custom_field_id = existingCustomFieldList?.map((item) => item.custom_field_id) || [];
      let remainingCustomFields = caseCustomFieldList?.filter((item) => !custom_field_id?.includes(item?.custom_field_id));

      let assignedLength = existingCustomFieldList?.length;
      let unassignedLength = remainingCustomFields?.length;

      let condition_1 = !assignedLength && unassignedLength; // no existing custom field
      let condition_2 = assignedLength && unassignedLength; // some + new custom field

      if (condition_1) {
        unassignedCustomField = remainingCustomFields;
      } else if (condition_2) {
        assignedCustomField = existingCustomFieldList;
        unassignedCustomField = remainingCustomFields;
      } else {
        assignedCustomField = existingCustomFieldList;
      }
    }

    if (caseDetails) {
      if (caseDescription.case_point_of_contact === undefined) {
        setValue('case_description.case_point_of_contact', true);
        caseDescription['case_point_of_contact'] = true;
      }
      let existingCaseDetailData = {
        case_description: {
          case_name: caseDescription?.case_name,
          review_requested: caseDescription?.review_requested,
          review_received: caseDescription?.review_received,
          case_point_of_contact: caseDescription?.case_point_of_contact,
          case_matter: caseDescription?.case_matter,
          office_location: caseDescription?.office_location,
          court: caseDescription?.court,
          venue: caseDescription?.venue,
          case_practice_area: caseDescription?.case_practice_area,
          // from details page
          case_number: caseDescription?.case_number,
          case_stage: caseDescription?.case_stage,
          date_of_loss_event: caseDescription?.date_of_loss_event ? new Date(caseDescription?.date_of_loss_event) : undefined,
          custom_field: assignedCustomField,
        },
        //from imp dates
        important_dates: {
          ...(caseDetails?.important_dates || {}),
          statute_of_limitations: caseDetails?.important_dates?.statute_of_limitations
            ? new Date(caseDetails?.important_dates?.statute_of_limitations)
            : '',
        },
        unassigned_custom_field: unassignedCustomField,
        online_lead_fields: caseDetails?.online_lead_fields,
      };
      if (isLeadSpecific) {
        // existing data from lead details page(summary and conflict page)
        let isLeadSpecificData = {
          description: caseDetails?.lead_details?.description,
          tags: caseDetails?.lead_details?.tags,
          lead_details: {
            conflict_check: caseDetails?.lead_details?.conflict_check,
            conflict_note: caseDetails?.lead_details?.conflict_note,
            conflict_contacts: caseDetails?.lead_details?.conflict_contacts,
          },
          case_description: {
            ...existingCaseDetailData.case_description,
            is_qualified: caseDescription?.is_qualified,
          },
        };
        reset({ ...existingCaseDetailData, ...isLeadSpecificData });
      }
      // existing data from case details page
      else {
        const clientDetails = caseDetails?.client_details;
        const defendant = caseDetails?.relations?.filter((relation) => relation._role_ === 'Defendant');

        // Map insurer ID to insurer name from insurance_details if available
        let insuranceCompany = clientDetails?.[0]?.insurance_company;
        if (!insuranceCompany && clientDetails?.[0]?.insurer && caseDetails?.insurance_details) {
          const matchedInsurer = caseDetails.insurance_details.find((ins) => ins?.insurer_id === clientDetails[0].insurer);
          if (matchedInsurer) {
            insuranceCompany = matchedInsurer.insurer_name;
          }
        }

        const updatedCaseDetails = {
          ...clientDetails[0],
          full_name: `${clientDetails?.[0]?.first_name} ${clientDetails?.[0]?.middle_name || ''} ${clientDetails?.[0]?.last_name}`
            .replace(/\s+/g, ' ')
            .trim(),
          insurance_company: insuranceCompany, // Set the mapped insurer name
        };

        // Keep insurer_id as-is for defendants - the Defendant.jsx component will handle display via dropdown
        // The dropdown now uses insurer_id as the value for uniqueness
        const updatedDefendants = defendant?.map((def) => {
          let defInsurerName = def?.insurer;
          // If insurer is an ID (looks like UUID), map it to name
          if (defInsurerName && caseDetails?.insurance_details && defInsurerName?.includes?.('-')) {
            const matchedInsurer = caseDetails.insurance_details.find((ins) => ins?.insurer_id === def.insurer);
            if (matchedInsurer) {
              return {
                ...def,
                insurer: matchedInsurer.insurer_id,
                policy_number: matchedInsurer.policy_number || def.policy_number,
                claim_number: matchedInsurer.claim_number || def.claim_number,
                insurance_limits: matchedInsurer.insurance_limit || def.insurance_limits,
              };
            }
          }
          return def;
        });

        let caseSpecificData = {
          description: caseDetailsField?.description,
          tags: caseDetailsField?.tags,
          is_create_client_portal: caseDetailsField?.is_create_client_portal,
          client_details: updatedCaseDetails,
          relations: caseDetails?.relations,
          defendant: updatedDefendants,
          lead_details: {
            conflict_check: caseDetailsField?.conflict_check,
            conflict_note: caseDetailsField?.conflict_note,
            conflict_contacts: caseDetailsField?.conflict_contacts,
          },
          dob: caseDetails?.client_details?.[0]?.dob ? parseDOB(caseDetails.client_details[0].dob) : null,
        };
        reset({ ...existingCaseDetailData, ...caseSpecificData });
      }
    }
  }, [caseDetails, caseCustomFieldList]);

  return (
    <>
      <GlobalLoader />
      <div className="text-end mb-3">
        {!isPersonalInjuryCase && userDetails.getPermission('cases') === AppConstants.permissions.WRITE && (
          <Button
            label="Save"
            className="btn-outline p-button-secondary py-1 px-3 "
            type="button"
            onClick={handleSubmit(handleUpdateCaseDetails)}
          />
        )}
      </div>
      <div className="row lead-summary">
        <div className="col-lg-6">
          {isPersonalInjuryCase && (
            <>
              <ClientInformation
                control={control}
                userDetails={userDetails}
                caseDetails={caseDetails}
                watch={watch}
                handleSubmit={handleSubmit}
                getCaseDetails={getCaseDetails}
                setValue={setValue}
                isLeadSpecific={isLeadSpecific}
                fetchLeadDetails={fetchLeadDetails}
              />
              {!caseDetails?.is_lead && (
                <Defendant
                  control={control}
                  userDetails={userDetails}
                  caseDetails={caseDetails}
                  handleSubmit={handleSubmit}
                  isLeadSpecific={isLeadSpecific}
                  fetchLeadDetails={fetchLeadDetails}
                  getCaseDetails={getCaseDetails}
                  setValue={setValue}
                  watch={watch}
                />
              )}
              {caseDetails?.is_lead && (
                <Card className="card-bg F-size14 mb-3 info-card">
                  <Summary
                    control={control}
                    userDetails={userDetails}
                    caseDetails={caseDetails}
                    watch={watch}
                    setValue={setValue}
                    handleSubmit={handleSubmit}
                    isLeadSpecific={isLeadSpecific}
                  />
                  <CaseDetailsUnmappedFields
                    field="online_lead_fields"
                    control={control}
                    setValue={setValue}
                    errors={errors}
                    watch={watch}
                  />
                  <CaseDetailsCustomFields
                    control={control}
                    userDetails={userDetails}
                    watch={watch}
                    setValue={setValue}
                    isLeadSpecific={isLeadSpecific}
                    caseCustomFieldList={caseCustomFieldList}
                  />
                </Card>
              )}
            </>
          )}
          {!isPersonalInjuryCase && (
            <>
              <Card className="card-bg F-size14 mb-3 info-card">
                <Summary
                  control={control}
                  userDetails={userDetails}
                  caseDetails={caseDetails}
                  watch={watch}
                  setValue={setValue}
                  getCaseDetails={getCaseDetails}
                  handleSubmit={handleSubmit}
                  isLeadSpecific={isLeadSpecific}
                />
                <CaseDetailsUnmappedFields field="online_lead_fields" control={control} setValue={setValue} errors={errors} watch={watch} />
                <CaseDetailsCustomFields
                  control={control}
                  userDetails={userDetails}
                  watch={watch}
                  setValue={setValue}
                  isLeadSpecific={isLeadSpecific}
                  caseCustomFieldList={caseCustomFieldList}
                />
              </Card>
            </>
          )}
        </div>
        <div className="col-lg-6">
          {isPersonalInjuryCase && (
            <div className="caption-bold mb-3 d-flex justify-content-between align-items-center">
              <span>Case Informations</span>
              <Button
                label="Update Case Details"
                className="btn-outline p-button-secondary py-1 px-3 "
                type="button"
                onClick={handleSubmit(handleUpdateCaseDetails)}
              />
            </div>
          )}
          <Card className="card-bg F-size14 mb-3 info-card">
            {isLeadSpecific && (
              <NeedResolution
                caseNoteList={caseNoteList}
                fetchCaseNotes={fetchCaseNotes}
                leadDetails={caseDetails}
                caseSecureMessages={caseSecureMessages}
                loadCaseSecureMessages={loadCaseSecureMessages}
                fetchLeadDetails={fetchLeadDetails}
              />
            )}
            {isPersonalInjuryCase && !caseDetails?.is_lead && (
              <>
                <Summary
                  control={control}
                  userDetails={userDetails}
                  caseDetails={caseDetails}
                  watch={watch}
                  setValue={setValue}
                  handleSubmit={handleSubmit}
                  isLeadSpecific={isLeadSpecific}
                />
                <CaseDetailsUnmappedFields field="online_lead_fields" control={control} setValue={setValue} errors={errors} watch={watch} />
                <CaseDetailsCustomFields
                  control={control}
                  userDetails={userDetails}
                  watch={watch}
                  setValue={setValue}
                  isLeadSpecific={isLeadSpecific}
                  caseCustomFieldList={caseCustomFieldList}
                />
              </>
            )}
            <InformationDetails
              control={control}
              caseDetails={caseDetails}
              isCaseClosed={isCaseClosed}
              setValue={setValue}
              isLeadSpecific={isLeadSpecific}
              errors={errors}
              watch={watch}
            />
            <CompanionCases caseDetails={caseDetails} />
            <ConflictCheck {...{ control, userDetails, caseDetails, isLeadSpecific, watch, setValue }} />
            <ImportantDates {...{ control, userDetails, caseDetails, isCaseClosed, isLeadSpecific, caseReopenDate, caseClosedDate }} />
          </Card>
        </div>
      </div>
      {!isPersonalInjuryCase && (
        <div className="footer-btn mb-5">
          {userDetails.getPermission('cases') === AppConstants.permissions.WRITE && (
            <Button
              label="Save"
              className="btn-outline p-button-secondary py-1 px-3 "
              type="button"
              onClick={handleSubmit(handleUpdateCaseDetails)}
            />
          )}
        </div>
      )}
    </>
  );
};
